/** Short prefixed id used for trips, days, and stops. */
export function generateId(prefix: string): string {
  return `${prefix}-${Math.random().toString(36).slice(2, 10)}`;
}
